import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["link", "menu", "icon"];

  connect() {
    this.setActiveClass();
  }

  setActiveClass() {
    let currentPath = this.stripLocale(window.location.pathname);

    this.linkTargets.forEach((link) => {
      let strippedLinkPath = this.stripLocale(link.pathname);
      let isActive = (strippedLinkPath === currentPath);
      this.toggleActiveClass(link, isActive);
      if (isActive) {
        this.handleActiveState(link);
      }
    });
  }

  activate(event) {
    let clickedLink = event.currentTarget;

    this.linkTargets.forEach((link) => {
      let isActive = (link === clickedLink);
      this.toggleActiveClass(link, isActive);

      if (isActive) {
        this.handleActiveState(link);
      }
    });
  }

  toggleActiveClass(link, isActive) {
    let activeClasses = [
      "ps-8",
      "text-[#0445D8]",
      "bg-[#E0E8FA]",
      "border-l-10",
      "rounded",
      "hover:bg-[#E0E8FA]",
    ];
    let passiveClasses = ["ps-10", "text-[#626262]", "hover:bg-gray-100"];

    activeClasses.forEach((className) =>
      link.classList.toggle(className, isActive)
    );
    passiveClasses.forEach((className) =>
      link.classList.toggle(className, !isActive)
    );
  }

  stripLocale(path) {
    let availableLocales = document.body.dataset.availableLocales.split(",");
    let localeRegex = new RegExp(`^/(${availableLocales.join("|")})(/|$)`);
    let match = path.match(localeRegex);

    if (match) {
      return path.replace(localeRegex, "/");
    }

    return path;
  }

  dropdown_toggle(event) {
    event.preventDefault();

    let isMenuVisible = this.menuTarget.style.display === "block";

    this.menuTarget.style.display = isMenuVisible ? "none" : "block";
    this.iconTarget.classList.toggle("fa-caret-right", isMenuVisible);
    this.iconTarget.classList.toggle("fa-caret-down", !isMenuVisible);
  }

  handleActiveState(link) {
    let dropDownMenu = link.closest('[data-sidebar-target="menu"]');
    if (dropDownMenu) {
      dropDownMenu.style.display = "block";

      let toggleIcon = dropDownMenu.previousElementSibling.querySelector('[data-sidebar-target="icon"]');
      if (toggleIcon) {
        toggleIcon.classList.remove("fa-caret-right");
        toggleIcon.classList.add("fa-caret-down");
      }
      link.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
}
